const collapseAccordion = (document) => {
  let el = document.getElementsByClassName('accordion-button')
  el = el.item(0)
  if (el.className.indexOf('collapsed') > -1) return
  el.click()
}

export default collapseAccordion
